<template>
    <section class="services-list">
        <div v-if="!isPndOsm" class="services-list__carousel">
            <swiper ref="swiper" :options="swiperOptions" @slideChange="onSlideChange">
                <swiper-slide v-for="(service, index) in services" :key="index">
                    <a :href="getServiceLink(service)" :target="service.open_new_window ? '_blank' : '_self'" class="services-list__item">
                        <div class="services-list__item-price" v-html="service.price"></div>
                        <div class="services-list__item-icon">
                            <img :src="service.icon">
                        </div>
                        <h4 class="services-list__item-name" v-html="service.title"></h4>
                        <div class="services-list__item-desc" v-html="service.text"></div>
                    </a>
                </swiper-slide>
                <div class="services-list__pagination" slot="pagination"></div>
            </swiper>
            <div class="services-list__navigation" v-if="showControls">
                <button @click="prev" class="prev" :class="{disabled: swiperProgress <= 0}"></button>
                <button @click="next" class="next" :class="{disabled: swiperProgress >= 1}"></button>
            </div>
        </div>
        <new-payment-form
            :servicesList="servicesListPopup"
            :currentService="currentService"
            :disable-payment="disablePayment"
            :stub-text="stubText"
        />
        <!-- Багфикс в рамках правок для IE DMDSUPP-8025 -->
        <!-- Форма вызывалась дважды, на главной и ОСМ,
        но если убрать не работат на ОСМ для IE.
        Осталяем форму только для IE -->
        <div class="invoice-pay__osm_ie" v-if="this.isPndOsm && this.isIE">
            <invoice-pay />
        </div>
    </section>
</template>

<script>
import {Swiper, SwiperSlide} from 'vue-awesome-swiper';
import 'swiper/css/swiper.css';
import newPaymentForm from "@/components/new-payment-form";
import InvoicePay from "@/components/invoicePay/index";

export default {
    name: 'ServicesList',
    components: {
        InvoicePay,
        Swiper,
        SwiperSlide,
        newPaymentForm
    },
    props: {
        services: {
            type: Array,
            required: true,
        },
        currentService: {
            type: String,
            default: ''
        },
        servicesListPopup: {
            type: Array,
            default: () => [
                {
                    id: 1221,
                    name: 'Оплата услуг скорой помощи'
                },
                {
                    id: 866,
                    name: 'Пополнение депозита (VIP договор)'
                },
                {
                    id: 869,
                    name: 'Оплата разовых услуг'
                }
            ]
        },
        disablePayment: {
            type: String,
            default: '0'
        },
        stubText: {
            type: String,
            default: '<div>Оплата временно недоступна</div>'
        },
    },
    data() {
        return {
            swiperOptions: {
                pagination: {
                    el: '.services-list__pagination',
                },
                touchReleaseOnEdges: true,
                breakpoints: {
                    320: {
                        slidesPerView: 1,
                        spaceBetween: 20,
                        loop: true,
                    },
                    768: {
                        slidesPerView: 2,
                        spaceBetween: 20,
                        loop: true,
                        watchSlidesVisibility: false,
                        watchSlidesProgress: false,
                    },
                    1025: {
                        slidesPerView: 3,
                        spaceBetween: 0,
                        loop: false,
                    },
                },
            },
            swiperProgress: 0,
            showControls: false,
            isPndOsm: window.location.href.includes('/osm/'),
            isPndMain: window.location.href.includes('/pnd/') && !window.location.href.includes('/osm/'),
            isIE: navigator.userAgent.toLowerCase().includes('rv:11.0') && navigator.userAgent.toLowerCase().includes('trident/7.0')
        }
    },
    methods: {
        prev() {
            this.$refs.swiper.$swiper.slidePrev();
        },
        next() {
            this.$refs.swiper.$swiper.slideNext();

        },
        getServiceLink(service) {
            if (!service.filters || !service.filters.length) {
                if (service.link) {
                    return service.link;
                } else if (service.file) {
                    return service.file;
                } else {
                    return '/pnd/help/'
                }
            }

            return `/pnd/help/?services=${service.filters.join(',')}`;
        },
        onSlideChange() {
            this.swiperProgress = this.$refs.swiper.$swiper.progress;
        },
    },
    mounted() {
        if (this.services.length > this.swiperOptions.breakpoints[this.$refs.swiper.$swiper.currentBreakpoint].slidesPerView) {
            this.showControls = true;
        }
        this.$refs.swiper.$swiper.on('breakpoint', function () {
            if (window.innerWidth >= 1025) {
                this.loopDestroy();
            } else {
                this.loopCreate();
            }
        });
    },
}
</script>
<style lang="scss">
@import "../../scss/base/include";

.services-list {
    @include tablet {
        display: flex;
        flex-direction: column;
    }
    @include mobile {
        position: relative;
    }

    &__preload {
        min-height: 448px;
        margin: 10px -60px 22px;
        padding: 0 60px;
        overflow: hidden;
        @include tablet {
            min-height: 387px;
            margin: 0;
            padding: 0;
        }
    }

    &__btn {
        position: relative;

        .services-list__navigation {
            display: none;
            @include tablet {
                display: block;
            }
            @include mobile {
                top: 12px;
            }
        }
    }

    &__top {
        position: relative;
        @include tablet {
            order: 1;
        }
        @include mobile {
            position: static;
        }
    }

    &__pagination {
        position: absolute;
        bottom: 0;
        text-align: center;
        @include tablet {
            transform: translateX(70px);
        }
        @include mobile {
            bottom: 15px !important;
            transform: none;
        }
    }

    &__navigation {
        position: static;

        @include mobile {
            display: none;
        }

        button {
            background-color: transparent;
            width: 39px;
            height: 39px;
            background-image: url(/local/templates/pnd/src/assets/i2/arrow.svg);
            background-position: 58% 50%;
            background-repeat: no-repeat;
            background-size: 9px auto;
            border: solid 1px $list-bullet;
            outline: none;
            border-radius: 50%;
            position: absolute;
            cursor: pointer;
            top: 50%;
            margin-top: -40px;
            z-index: 10;
            @include mobile {
                width: 28px;
                height: 28px;
                background-size: 7px auto;
            }

            &.disabled {
                @include tablet-min {
                    pointer-events: none;
                    cursor: default;
                    opacity: 0.3;
                    border-color: $border;
                }
            }

            &.prev {
                transform: scale(-1, 1);
                left: -20px;
                @include low-desktop {
                    left: -10px;
                }
                @include tablet {
                    display: none;
                }
            }

            &.next {
                right: -20px;
                margin-left: 5px;
                @include low-desktop {
                    right: -10px;
                }
                @include tablet {
                    right: -70px;
                }
                @include mobile {
                    margin-left: 4px;
                }
            }
        }
    }

    &__carousel {
        margin: 10px -40px 22px;
        padding: 0 20px;
        position: relative;
        @include low-desktop {
            margin: 10px -20px 22px;
        }
        @include tablet {
            max-width: calc(100% - 70px);
            margin: 0;
            padding: 0;
        }
        @include mobile {
            max-width: 100%;
        }
    }

    &__item {
        box-shadow: 10px 14px 50px rgba(229, 233, 246, 0.8);
        background-color: $white-true;
        height: 100%;
        padding: 40px 27px 44px;
        border-radius: 20px;
        position: relative;
        display: block;
        text-decoration: none;
        transition: all ease .3s;
        -webkit-tap-highlight-color: rgba(0, 0, 0, 0);

        &:hover {
            background: $bg-light2;

            .services-list__item-price {
                background: $accent;
                color: $white-true;
            }

            .services-list__item-desc {
                color: $gray2;
            }
        }

        @include tablet {
            max-width: 100%;
            padding: 40px 16px 23px 20px;
        }

        &-price {
            position: absolute;
            background: $bg-light2;
            color: $accent;
            font-weight: 500;
            line-height: 20px;
            border-top-right-radius: 10px;
            border-bottom-left-radius: 10px;
            padding: 10px 25px;
            transition: all ease .3s;
            top: 0;
            right: 0;
            @include tablet {
                padding: 5px 10px;
                font-size: 16px;
            }
        }

        &-icon {
            height: 90px;
            margin-bottom: 46px;
            @include tablet {
                height: 87px;
                margin-bottom: 15px;
                img {
                    max-height: 100%;
                }
            }
        }

        &-image {
            width: 220px;
            height: 222px;
            border-radius: 50%;
            margin-bottom: 15px;
            background-position: center;
            background-size: cover;
            @include tablet {
                @include size(204px, 206px);
                margin-bottom: 31px;
            }
        }

        &-name {
            margin-bottom: 15px;
            color: $text-alt;
            @include tablet {
                font-size: 20px;
                line-height: 23px;
                margin-bottom: 11px;
            }
        }

        &-desc {
            font-size: 16px;
            line-height: 26px;
            font-family: 'HelveticaNeue';
            color: $gray2;
            @include tablet {
                line-height: 24px;
            }
        }
    }

    .swiper-container {
        overflow: visible;
    }

    .swiper-wrapper {
        padding: 22px 0 47px;
    }

    .swiper-slide {
        padding: 0 20px;
        box-sizing: border-box;
        height: auto;
        opacity: 0;
        transition: opacity .3s linear;
        @include tablet {
            padding: 0;
            transition: unset;
        }

        @include mobile {
            opacity: 1;
        }

        &.swiper-slide-visible {
            @include tablet {
                opacity: 1 !important;
            }
        }

        &.swiper-slide-active {
            opacity: 1;
        }

        &.swiper-slide-next {
            opacity: 1;

            & + .swiper-slide {
                opacity: 1;

                @include tablet {
                    opacity: 0;
                }
            }
        }
    }

    .swiper-pagination {
        bottom: 0;
        @include mobile {
            bottom: 20px;
        }

        &-bullet {
            width: 7.78px;
            height: 7.78px;
            border-radius: 50%;
            background-color: $bg-light2;
            margin: 0 3px;
            opacity: 1;
            @include mobile {
                width: 6.22px;
                height: 6.22px;
                margin: 0 2px;
            }

            &-active {
                background-color: $accent;
            }

            /* не отображать если точек <= 1 */
            &:nth-last-child(-n + 1):first-child,
            &:nth-last-child(-n + 1):first-child ~ & {
                display: none;
            }
        }
    }
}
</style>
